/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Claims_TitleInputs */

const en_dashboard_claims_title = /** @type {(inputs: Dashboard_Claims_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claims`)
};

const fr_dashboard_claims_title = /** @type {(inputs: Dashboard_Claims_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamations`)
};

/**
* | output |
* | --- |
* | "Claims" |
*
* @param {Dashboard_Claims_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_claims_title = /** @type {((inputs?: Dashboard_Claims_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Claims_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_claims_title(inputs)
	return fr_dashboard_claims_title(inputs)
});